import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
var Dialog = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, children = _a.children;
    var dialogRef = useRef(null);
    useEffect(function () {
        var handleEscape = function (event) {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        var handleClickOutside = function (event) {
            if (dialogRef.current && !dialogRef.current.contains(event.target)) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.addEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = 'hidden';
        }
        return function () {
            document.removeEventListener('keydown', handleEscape);
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);
    if (!isOpen)
        return null;
    // Render the dialog in a portal at the end of <body>
    return ReactDOM.createPortal(_jsx("div", { className: "dialog-overlay", role: "dialog", "aria-modal": "true", children: _jsxs("div", { className: "dialog-content", ref: dialogRef, children: [_jsxs("div", { className: "dialog-header", children: [_jsx("h2", { children: title }), _jsx("button", { type: "button", className: "dialog-close", onClick: onClose, "aria-label": "Close dialog", children: "\u00D7" })] }), _jsx("div", { className: "dialog-body", children: children })] }) }), document.body);
};
export default Dialog;
